import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { TableError } from '../../types/common';
import {
  FeeService,
  Wealthlane_AwardService_Dtos_Fee_UpdateSecFeeDto,
} from '@wealthlane/api-services/wealthlane-award-service';

function toSecFeeRate(rate: unknown): number | undefined {
  if (rate == null || rate === '') return undefined;
  if (typeof rate === 'number') return rate;
  const parsed = Number(String(rate).replaceAll(',', ''));
  return Number.isNaN(parsed) ? undefined : parsed;
}

function toUpdateSecFeeBody(payload: unknown): Array<Wealthlane_AwardService_Dtos_Fee_UpdateSecFeeDto> {
  const items = Array.isArray(payload) ? payload : [payload];
  return items.map((item: Record<string, unknown>) => ({
    id: item.id as string | undefined,
    effectiveDate: item.effectiveDate as string | undefined,
    rate: toSecFeeRate(item.rate),
  }));
}

const usePutSecFee = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onClose: () => void,
  onError: (message: string, errors: TableError[]) => void,
  setEditLoading?: (loading: boolean) => void
): UseMutationResult<
  Array<Wealthlane_AwardService_Dtos_Fee_UpdateSecFeeDto>,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload) => {
      setEditLoading && setEditLoading(true);

      return await handleRequest(FeeService.putApiAwardApiAppFeeSecFee(toUpdateSecFeeBody(payload)));
    },
    {
      onSuccess: async (response: any) => {
        if (response !== null && response?.isSuccess) {
          await queryClient.invalidateQueries('getSecFeeList');
          await queryClient.invalidateQueries('dt-v2-page');
          setEditLoading && setEditLoading(false);
          onClose && onClose();
          toast.success(<ToastComponent label='Success' message={`SEC Fee Edited.`} />);
        } else {
          throw {
            message: response?.message,
            errors: response?.errors,
            error: new Error(),
          };
        }
        onClose && onClose();
        setEditLoading && setEditLoading(false);
      },
      onError: (err: any) => {
        console.log('error', err);
        setEditLoading && setEditLoading(false);
        onError && onError(err?.message, err?.errors);
        onClose && onClose();
      },
    }
  );
};

export default usePutSecFee;
